import { render, staticRenderFns } from "./CustomFieldNumber.vue?vue&type=template&id=374f2160"
import script from "./CustomFieldNumber.vue?vue&type=script&lang=js"
export * from "./CustomFieldNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports